import cn from 'classnames'
import React from 'react'
import Link from '../common/util/input/Link'

const PreviewCard = ({
    link,
    title,
    children,
    background = 'bg-paper',
    backgroundClass,
}) => {
    return (
        <Link
            href={link}
            className={cn(
                background,
                'h-28 md:h-20 lg:h-28 xl:h-32 1xl:h-36 2xl:h-44 3xl:h-56 hover:text-shine mx-3 my-3 lg:my-0 shadow rounded-2xl',
            )}
        >
            <div
                className={cn(
                    'flex w-full h-full p-2 md:p-5 bg-right-top bg-cover bg-no-repeat rounded-2xl',
                    backgroundClass,
                )}
            >
                <div
                    className={cn(
                        'm-auto font-semibold text-white dark:text-white text-black text-center md:text-left',
                        'text-lg md:text-xs lg:text-sm xl:text-xl 2xl:text-2xl 3xl:text-3xl',
                    )}
                >
                    {title}
                </div>
            </div>
        </Link>
    )
}

export default PreviewCard
